// @flow

import * as React from 'react';
import { Box } from 'grommet';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getSidePanelState } from 'esm-web-pro/redux/side-panel';
import { isEmpty } from 'lodash';


type Props = React.ElementConfig<Box>;

const StyledRightShadow = styled(Box)`
    height: 100%;
    width: 100%;
    overflow: auto;
    ${(props) => `box-shadow: inset -10px 0px 10px -5px ${props.shadowColor};`}
`;


const RightShadow = (props: Props) => {
    const { children } = props;
    const sidePanel = useSelector(getSidePanelState);

    return (
        <StyledRightShadow
            {...props}
            shadowColor={isEmpty(sidePanel) ? '#d7d7d7' : '#e2e2e2'}
        >
            {children}
        </StyledRightShadow>
    );
};

RightShadow.defaultProps = {

};

export default RightShadow;
